import triggerTracking from '@blueprint/tracking';
import { TRACKING_EVENT } from 'listing-details/constants';
import { getMortgageCalculatorDetails } from 'shared/components/Calculator/utils/getMortgageLinkType';
import { createTrackingLabel } from 'shared/components/Calculator/utils/createTrackingLabel';
import { MortgageCalculatorProps } from './MortgageCalculator.types';

export const MORTGAGE_CALCULATOR_CATEGORY = 'mortgage calculator';

export const createMortgageTrackingLabel = ({
    data,
    listingSection
}: MortgageCalculatorProps) => {
    const mortgageDetails = getMortgageCalculatorDetails(
        data.analyticsTaxonomy.regionName,
        data.analyticsTaxonomy.listingStatus,
        data.analyticsTaxonomy.listingCondition
    );

    const label = createTrackingLabel({
        name: mortgageDetails.shortname,
        section: listingSection
    });

    return label;
};

export const clickTracking = (label: string) =>
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: MORTGAGE_CALCULATOR_CATEGORY,
        eventAction: 'clickout',
        eventLabel: label
    });
